import * as React from "react";

import {IParkingPlace} from "../../../property/interfaces/IParkingPlace";
import {IRangeQuery} from "../../../request/IRangeQuery";
import {VendorType} from "../../../vendor/helpers/VendorType";
import {IRoomRange} from "./OfferDetailGeneratedDescription";
import {OfferDetailGeneratedDescriptionParkingPlaces} from "./OfferDetailGeneratedDescriptionParkingPlaces";
import {OfferDetailGeneratedDescriptionRoomRanges} from "./OfferDetailGeneratedDescriptionRoomRanges";
import {OfferGeneratedDescriptionTextHouses} from "./OfferGeneratedDescriptionTextHouses";

interface IProps {
    className?: string;
    offer: {
        construction_date_range: IRangeQuery<string>;
        investor: string | null;
        name: string;
        parking_places: IParkingPlace[];
        properties: number;
        stats: {
            all_house_types: Record<string, number>;
            properties_count_for_sale: number;
            ranges_area_min: number;
            ranges_area_max: number;
            ranges_price_min: number;
            rooms_ranges: IRoomRange[];
        } | null;
        storage: {
            quantity: number;
            description: string;
            price: number;
        };
        type: number;
        vendor: {
            type: VendorType;
            name: string;
        };
    };
}

export const OfferDetailGeneratedDescriptionHouse = ({offer}: IProps) => {
    return (
        <>
            <OfferGeneratedDescriptionTextHouses offer={offer} />

            <OfferDetailGeneratedDescriptionRoomRanges header="Dostępne są domy:" rooms_ranges={offer.stats?.rooms_ranges ?? []} type={offer.type} />

            <OfferDetailGeneratedDescriptionParkingPlaces
                parking_places={offer.parking_places}
                investor={offer.investor}
                vendor={offer.vendor}
                offerName={offer.name}
            />
        </>
    );
};
import * as React from "react";

import {IParkingPlace} from "../../../property/interfaces/IParkingPlace";
import {IRangeQuery} from "../../../request/IRangeQuery";
import {VendorType} from "../../../vendor/helpers/VendorType";
import {IRoomRange} from "./OfferDetailGeneratedDescription";
import {OfferDetailGeneratedDescriptionParkingPlaces} from "./OfferDetailGeneratedDescriptionParkingPlaces";
import {OfferDetailGeneratedDescriptionRoomRanges} from "./OfferDetailGeneratedDescriptionRoomRanges";
import {OfferGeneratedDescriptionTextHouses} from "./OfferGeneratedDescriptionTextHouses";

interface IProps {
    className?: string;
    offer: {
        construction_date_range: IRangeQuery<string>;
        investor: string | null;
        name: string;
        parking_places: IParkingPlace[];
        properties: number;
        stats: {
            all_house_types: Record<string, number>;
            properties_count_for_sale: number;
            ranges_area_min: number;
            ranges_area_max: number;
            ranges_price_min: number;
            rooms_ranges: IRoomRange[];
        } | null;
        storage: {
            quantity: number;
            description: string;
            price: number;
        };
        type: number;
        vendor: {
            type: VendorType;
            name: string;
        };
    };
}

export const OfferDetailGeneratedDescriptionHouse = ({offer}: IProps) => {
    return (
        <>
            <OfferGeneratedDescriptionTextHouses offer={offer} />

            <OfferDetailGeneratedDescriptionRoomRanges header="Dostępne są domy:" rooms_ranges={offer.stats?.rooms_ranges ?? []} type={offer.type} />

            <OfferDetailGeneratedDescriptionParkingPlaces
                parking_places={offer.parking_places}
                investor={offer.investor}
                vendor={offer.vendor}
                offerName={offer.name}
            />
        </>
    );
};
